var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"svg","imageName":"PerkSpot","routePath":"perkspot","company":"PerkSpot"}})
}
var staticRenderFns = []

export { render, staticRenderFns }